/**
 * Area budget sidebar flyout configuration (Survey, Drilling, Recording, Base Camp).
 */

export const AREA_BUDGET_NAV_CONFIG = {
  survey: {
    budgetType: 'survey',
    baselineType: 'survey',
    menuRoute: '/budgets/survey',
    routePrefix: '/budgets/survey',
    newPath: '/budgets/survey/new',
    legacyNewMenuRoute: '/budgets/survey/new',
    legacyListMenuRoute: '/budgets/management?area=survey',
    flyoutTitle: 'Survey Budget',
    moduleLabel: 'Survey Budget',
    isBudgetPage: (pathname) => pathname.startsWith('/budgets/survey'),
  },
  drilling: {
    budgetType: 'drilling',
    baselineType: 'drilling',
    menuRoute: '/budgets/drilling',
    routePrefix: '/budgets/drilling',
    newPath: '/budgets/drilling/new',
    legacyNewMenuRoute: '/budgets/drilling/new',
    legacyListMenuRoute: '/budgets/management?area=drilling',
    flyoutTitle: 'Drilling Budget',
    moduleLabel: 'Drilling Budget',
    isBudgetPage: (pathname) => pathname.startsWith('/budgets/drilling'),
  },
  recording: {
    budgetType: 'recording',
    baselineType: 'recording',
    menuRoute: '/budgets/recording',
    routePrefix: '/budgets/recording',
    newPath: '/budgets/recording/new',
    legacyNewMenuRoute: '/budgets/recording/new',
    legacyListMenuRoute: '/budgets/management?area=recording',
    flyoutTitle: 'Recording Budget',
    moduleLabel: 'Recording Budget',
    isBudgetPage: (pathname) => pathname.startsWith('/budgets/recording'),
  },
  basecamp: {
    budgetType: 'basecamp',
    baselineType: 'management',
    menuRoute: '/budgets/basecamp',
    routePrefix: '/budgets/basecamp',
    newPath: '/budgets/basecamp/new',
    legacyNewMenuRoute: '/budgets/new',
    legacyListMenuRoute: '/budgets/management?area=basecamp',
    flyoutTitle: 'Base Camp Budget',
    moduleLabel: 'Base Camp Budget',
    isBudgetPage: (pathname) => (
      pathname.startsWith('/budgets/basecamp')
      || pathname === '/budgets/new'
      || pathname.startsWith('/budgets/edit/')
    ),
  },
};

export function getAreaBudgetNavConfig(area) {
  return AREA_BUDGET_NAV_CONFIG[area] ?? null;
}
